module.exports = __webpack_public_path__ + "img/banner_right_1.95c352ca.png";